import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

const NavButton = styled(IconButton)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 50%;
    box-shadow:
        0px 0px 8px 0px rgba(0, 0, 0, 0.12),
        0px 8px 8px 0px rgba(0, 0, 0, 0.24);
    width: 40px;
    height: 40px;

    &:hover:not(:disabled) {
        background-color: ${colorsPalettes.carbon[0]};
    }

    &:disabled {
        display: none;
    }
`;

export const Prev = styled(NavButton)`
    left: -20px;
`;

export const Next = styled(NavButton)`
    right: -20px;
`;
